import { render, staticRenderFns } from "./StockTakingImportExport.vue?vue&type=template&id=83af88cc"
import script from "./StockTakingImportExport.vue?vue&type=script&lang=js"
export * from "./StockTakingImportExport.vue?vue&type=script&lang=js"
import style0 from "./StockTakingImportExport.vue?vue&type=style&index=0&id=83af88cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports